module.exports = __webpack_public_path__ + "a768e7de/img/share-icon.0f8a11b4.svg";